module.exports = __webpack_public_path__ + "static/media/mapa-a9.512e8b4d.png";